/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { useSMOrganizationPage } from '../../OrganizationProfile/machines';
import { Col, Row, Card, Button, Image } from 'react-bootstrap';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

import {
  HeroSection,
  EditProfileModal,
  UpdateModal,
  Header,
} from '../components';
import { useSMupdateProfile, useSMmyProfilePage } from '../machines';
import { VApplication } from '../../../application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { MyProfilePageService } from '../services';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.MyProfilePageService') as MyProfilePageService;
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();

  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});

  const theme = useTheme();

  const { myProfilePageMachine, myProfilePageSend, myProfilePageState } =
    useSMmyProfilePage({});

  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      if (!showModal) {
        setShowModal(true);
      }
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
    if (updateModal) {
      setUpdateModal(false);
    }
  };
  const onEditProfile = (
    name: string,
    description: string,
    phoneNumber: string,
    address: string,
    website: string,
    profileImg?: string
  ) => {
    const payload: any = {};
    if (name) {
      payload.name = name;
    }
    if (description) {
      payload.description = description;
    }
    if (phoneNumber) {
      payload.telephone = phoneNumber;
    }
    if (address) {
      payload.address = {
        addressLine1: address,
      };
    }
    if (website) {
      payload.website = website;
    }
    if (profileImg) {
      payload.logo = profileImg;
    }
    updateProfileSend('START', {
      payload: payload,
    });
  };
  const onRefresh = () => {
    myProfilePageSend('TRIGGER_REFRESH', {});
  };
  const onUpdateProfile = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    updateProfileSend('START', {
      payload: {
        ...data,
      },
    });
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onUpdateProfile}
          onHide={() => setShowModal(false)}
          title={'Update Profile'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.editProfile?.FIELDS,
            layout: staticPageContentConfig?.editProfile?.layout,
            validatorConfig:
              staticPageContentConfig?.editProfile?.validatorConfig,
            initialData: myProfilePageState?.event?.data?.value?.initialData,
          }}
        />
      );
    }
  };

  const _renderPage = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.updateProfile || {})}
        />
      );
    }
    if (myProfilePageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <HeroSection
            {...(myProfilePageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
          />
        </>
      );
    }
    if (myProfilePageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (myProfilePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.updateProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderNotification = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header {...(staticPageContentConfig?.header || {})} />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderModal()}
      {_renderErrorModals()}
      {_renderNotification()}
    </>
  );
};
